<template>
  <v-icon v-text="icon" small class="mt-2 mr-2" />
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: Number,
      },
      threshold: {
        required: true,
        type: [Number, String],
      },
    },

    computed: {
      icon () {
        return this.value >= parseInt(this.threshold)
          ? this.icons.circleFull
          : this.icons.circleBlank
      },
    },
  }
</script>
